import apiClient from './apiClient';

export interface FT121 {
  ft121_01: string;         // 公告序號 (PK)
  ft121_11: string | null;  // 開始日期 (ISO string)
  ft121_12: string | null;  // 結束日期 (ISO string)
  ft121_13: string;         // (備用)
  ft121_14: string;         // (備用)
  ft121_21: string;         // 公告主題
  ft121_22: string;         // 公告內容
  ft121_91: string;         // 建立人員
  ft121_92: string | null;  // 建立日期 (ISO string)
  ft121_93: string;         // 修改人員
  ft121_80: string;         // 保留欄位（審核流已拆除，2026-06-12 依使用者裁決——公告建檔即生效）
}

export interface ListResponse {
  data: FT121[];
  total: number;
  page: number;
  size: number;
}

export const t102Api = {
  async list(page = 1, size = 100): Promise<ListResponse> {
    return (await apiClient.get('/api/t102', { params: { page, size } })).data;
  },
  async search(keyword: string, page = 1, size = 100): Promise<ListResponse> {
    return (await apiClient.get('/api/t102/search', { params: { keyword, page, size } })).data;
  },
  async get(code: string): Promise<FT121> {
    return (await apiClient.get(`/api/t102/${encodeURIComponent(code)}`)).data;
  },
  async create(data: Partial<FT121>): Promise<FT121> {
    return (await apiClient.post('/api/t102', data)).data;
  },
  async update(code: string, data: Partial<FT121>): Promise<FT121> {
    return (await apiClient.put(`/api/t102/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/t102/${encodeURIComponent(code)}`);
  },
  async copy(sourceCode: string, newCode: string): Promise<FT121> {
    return (await apiClient.post(`/api/t102/${encodeURIComponent(sourceCode)}/copy`, { new_code: newCode })).data;
  },

  // 審核流 API 已拆除（批次 5，2026-06-12 依使用者裁決移除——FoxPro 規格
  // 無公告審核概念，公告建檔即發布生效，原 submit/approve/reject/writeoff 為重建版誤加）
};
